import React from 'react';
import { createPortal } from 'react-dom';
import { ASComponentSize } from 'types/App.types';
import styles from './ASLoader.module.scss';
import { LoaderType, SizeToCLsType } from './ASLoader.types';

const SizeToCls: SizeToCLsType = {
  [ASComponentSize.Small]: styles.ASSmall,
  [ASComponentSize.Medium]: styles.ASMedium,
  [ASComponentSize.Large]: styles.ASLarge,
};

type ASLoaderProps = {
  className?: string;
  loaderType?: LoaderType;
  loaderSize?: ASComponentSize;
  showLoader?: boolean;
  isModal?: boolean;
};

const ASLoader: React.FC<ASLoaderProps> = ({
  className = '',
  loaderType = LoaderType.Grow,
  loaderSize = ASComponentSize.Medium,
  isModal = false,
  ...props
}) => {
  const modalBaseCls = `${styles.ASLoaderModalContainer} ${className}`;
  const nonModalBaseCls = `${styles.ASLoaderNonModalContainer} ${className}`;

  const renderLoader = () => {
    switch (loaderType) {
      case LoaderType.Spin:
        return <ASLoaderSpin size={loaderSize} />;
      case LoaderType.Dots:
        return <ASLoaderDots size={loaderSize} />;
      case LoaderType.Grow:
      default:
        return <ASLoaderGrow size={loaderSize} />;
    }
  };


  const renderLoaderModal = () => {
    return (
      <>
        {props.showLoader &&
          createPortal(
            <>
              <div className={`${modalBaseCls}`}>{renderLoader()}</div>
            </>,
            document.body
          )}
      </>
    );
  };

  const renderLoaderNonModal = () => {
    return <>{props.showLoader && <div className={`${nonModalBaseCls}`}>{renderLoader()}</div>}</>;
  };

  return <>{isModal ? renderLoaderModal() : renderLoaderNonModal()}</>;
};

type LoaderDetailsProps = {
  size: ASComponentSize;
};

const ASLoaderGrow: React.FC<LoaderDetailsProps> = ({ size = ASComponentSize.Large }) => {
  return (
    <div className={`${styles.ASLoaderGrow} ${SizeToCls[size]}`}>
      <span className={styles.ASLoaderText}>LOADING</span>
    </div>
  );
};
const ASLoaderDots: React.FC<LoaderDetailsProps> = ({ size = ASComponentSize.Large }) => {
  return <div className={`${styles.ASLoaderDots} ${SizeToCls[size]}`}></div>;
};
const ASLoaderSpin: React.FC<LoaderDetailsProps> = ({ size = ASComponentSize.Large }) => {
  return (
    <div className={`${styles.ASLoaderSpinWrapper} ${SizeToCls[size]}`}>
      <div className={`${styles.ASLoaderSpin} ${SizeToCls[size]}`}></div>
    </div>
  );
};

export { ASLoader as default, LoaderType };
